import React from 'react';
import styled from 'styled-components';

export function FormErrorMessage(props) {
    return <ErrorMessageText>{props.children}</ErrorMessageText>;
}

export const ErrorMessageText = styled.div`
    color: var(--danger);
    font-size: var(--text-size-small);
    font-weight: 400;
    * {
        color: var(--danger);
        font-size: var(--text-size-small);
        font-weight: 400;
    }
`;
